'use strict';

module.exports = /* @ngInject */ function ($scope, feAccountingToClassificationService, $http, apiConfig) {

    $scope.isLoading = true;
    $scope.tree = {};
    $scope.levels = {};
    $scope.expanded = [];
    $scope.accounts = [];
    $scope.eClass = {};

    var relationsToPersist = [];

    $scope.init = init;
    $scope.loadLevel = loadLevel;
    $scope.toggleShow = toggleShow;
    $scope.onSave = onSave;

    $scope.init();

    function init() {
        loadLevel(null);
        loadAccountsForUser();
    }

    /**
     * Prepare collected data and post to server for saving.
     */
    function onSave() {
        relationsToPersist = []; // clear list
        // prepare collected data to match backend object
        $.each($scope.eClass, function(key, value) {
            if(value.previousAccountId !== null || value.currentAccountId !== null) {
                const previousAccountId = value.previousAccountId === null ? null : value.previousAccountId.id;
                const currentAccountId = value.currentAccountId === null ? null : value.currentAccountId.id;
                relationsToPersist.push({"eClassId": key, "previousAccountId": previousAccountId, "currentAccountId": currentAccountId});   
            }        
        });

        $http({
            url: apiConfig.apiUrl + '/classifycode',
            method: "POST",
            data:  relationsToPersist
        })
        .then(function(response) {
            growl('Daten erfolgreich gespeichert');
        }, function(error) {
            growl('Beim Speichern der Daten ist ein Fehler aufgetreten.', 1);
        });
    }

    /**
     * Load accounts corresponding to the current user.
     */
    function loadAccountsForUser() {
        feAccountingToClassificationService.accounts.query()
        .$promise.then(
            function(data) {
                $scope.accounts = data;
                $scope.isLoading = false;
            }
        )
    }

    /**
     * Toggle the visibility of the sublevel tree of the parent which was clicked.
     * 
     * @param {*string} irdicc - irdicc of the eClass 
     */
    function toggleShow(irdicc) {
        $scope.expanded[irdicc] = $scope.expanded[irdicc] === null || $scope.expanded[irdicc] === undefined 
        || $scope.expanded[irdicc] === false;
    }

    /**
     * Load the sublevel for the given coded name. If the coded name is null, the top
     * level eClass will be loaded.
     * 
     * @param {*string} codedName - eClass coded name - might be null
     */
    function loadLevel(codedName) {
        // only load level from server if it is not already present in scope
        if($scope.levels[codedName] === null || $scope.levels[codedName] === undefined) {
            feAccountingToClassificationService.treeLevel.query(
                {
                    codedName: codedName,
                    classificationId: null
                })
            .$promise.then(
                //success
                function(data) {
                    if(codedName === null) {
                        $scope.tree = data;
                        mapExistingAccountsToLocalList($scope.tree);
                    } else {
                        $scope.levels[codedName] = data;
                        mapExistingAccountsToLocalList($scope.levels[codedName]);
                    }
                },
                //error
                function(err) {
                    growl(err.data.msg, 1);
                }
            );
        }
    }

    /**
     * Map the given list to the internally used structure.
     * 
     * @param {*list} eClassListWithAccounts - list of eClasses with corresponding accounts if present
     */
    function mapExistingAccountsToLocalList(eClassListWithAccounts) {
        $.each(eClassListWithAccounts, function(key, value) {
            if(value.accounts !== null) {
                $scope.eClass[value.irdicc] = {"previousAccountId": value.accounts[0], "currentAccountId": value.accounts[0]};
            } else {
                $scope.eClass[value.irdicc] = {"previousAccountId": null, "currentAccountId": null};
            }
        });
    }

	/**
	 * Filters accounts based on a input string.
	 * @param searchText - string to filter accounts by
	 * @returns T[] - filtered array of accounts
	 */
	$scope.filterAccounts = function (searchText){
    	if(!searchText) {
    		return $scope.accounts.slice();
		} else {
    		return $scope.accounts.filter(function(account){
    			return (account.key + ' - ' + account.name).toLowerCase().indexOf(searchText.toLowerCase()) <= 0
			}).sort(function(a,b) {
				if(a.name < b.name ){
					return 1;
				} else {
					return -1;
				}
			});
		}
	}

};
